const ZATTOO_CHANNEL_PLACEHOLDER = '{channel}'

export const createZattooUrl = (templateUrl: string, channel: string) =>
  templateUrl.replace(ZATTOO_CHANNEL_PLACEHOLDER, channel)
